/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Entity from 'fierry/data/entity';


export default class Influence extends Entity
{
  getID ()
  {
    return this.cass.targetZone + ':' + this.cass.sourceColony;
  }


  getSourceColony ()
  {
    return this.parent.getColony(this.cass.sourceColony);
  }


  getSourceUserID ()
  {
    return this.getSourceColony().cass.user;
  }


  getBoard ()
  {
    return this.parent;
  }


};
